import { atom } from "jotai";

export const isConfigDialogOpenAtom = atom<boolean>(false);
